import { lazy } from "react";

const RELOAD_KEY = "chunk-load-reload-at";
const RELOAD_WINDOW_MS = 10000;

const isChunkLoadError = (error) =>
  error?.name === "ChunkLoadError" ||
  /Loading chunk [\w.-]+ failed/.test(error?.message || "");

/**
 * React.lazy con un reintento: si un chunk hasheado ya no existe
 * (despliegue reciente), recarga una vez para pedir el index.html nuevo.
 */
export function lazyWithRetry(importFn) {
  return lazy(() =>
    importFn().catch((error) => {
      if (!isChunkLoadError(error)) {
        throw error;
      }

      const lastReload = Number(sessionStorage.getItem(RELOAD_KEY) || 0);
      if (Date.now() - lastReload < RELOAD_WINDOW_MS) {
        throw error;
      }

      sessionStorage.setItem(RELOAD_KEY, String(Date.now()));
      window.location.reload();
      return new Promise(() => {});
    })
  );
}
